import { render, staticRenderFns } from "./sglEventGroups.vue?vue&type=template&id=03c7a8b3&scoped=true&"
import script from "./sglEventGroups.vue?vue&type=script&lang=js&"
export * from "./sglEventGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c7a8b3",
  null
  
)

export default component.exports